import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

//Styles
import "./EnergySection.css";

//Context
import { NavbarContext } from "../../context/NavbarContext";

const EnergySection = () => {
  const { energy } = useContext(NavbarContext);

  const { t } = useTranslation();

  return (
    <section ref={energy} className="ene-section-container" id="energy">
      <img
        className="ene-bg"
        src="https://pagina-otacc.s3.us-east-1.amazonaws.com/pages/otacc-page/assets/home-bgs/home-bg-2-temp.webp"
        alt="Imagen de fondo de la sección de proyectos energéticos."
      />
      <div className="ene-btn-container">
        <Link to="/renovables" className="ene-btn" title="Energía">
          {t("home.button_text")}
        </Link>
      </div>
    </section>
  );
};

export default EnergySection;
